import React, { useState, useEffect } from 'react';
import quotes from './data/quotes'
import './QuotePart.css'

function QuotePart({ fontColor, fontSize }) {
	const [quoteContent, setQuoteContent] = useState("");
	const [quote, setQuote] = useState({});

	const getAleatoryQuote = () => {
		setQuote(quotes[Math.floor(Math.random() * (quotes.length - 1 + 1))]);
	}


	const printQuote = async (_quote) => {
		if (_quote.quote != undefined) {
			let result = "";
			for (let i = 0; i < _quote.quote.length; i++) {
				result += _quote.quote[i]
				setQuoteContent(result)
				await timeout(75);
			}
		}

		//let size = quote.quote.length

		//for (let i = 0; i < quote.quote.length; i++) {
		//setQuoteContent(quoteContent + quote.quote[i])
		//}

	}
	useEffect(() => {    // Met à jour le titre du document via l’API du navigateur    
		getAleatoryQuote();
		//printQuote(quote);
	}, []);

	useEffect(() => {
		printQuote(quote)
	}, [quote])


	function timeout(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	return (
		<div className="container-quote">
			<div className="svg-quote" style={{ minHeight: parseInt(fontSize) + 10 + "px", minWidth: parseInt(fontSize) + 10 + "px", backgroundColor: fontColor, marginLeft:"0px" }}></div>
			<span className="quote" style={{ color: fontColor, fontSize: fontSize + "px" }}> {quoteContent}</span>
			<span className="author" style={{ color: fontColor, fontSize: fontSize / 2 + "px" }}>— {quote.author}</span>
		</div>
	);
}
export default QuotePart;